(function($) {
	"use strict"; 

   var mobileMenuOutsideClick = function() {

    $(document).click(function (e) {
      var container = $("#site-offcanvas, .js-site-nav-toggle");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.js-site-nav-toggle').addClass('site-nav-white');

        if ( $('body').hasClass('offcanvas') ) {

          $('body').removeClass('offcanvas');
          $('.js-site-nav-toggle').removeClass('active');
        
        }   
      }
    });

  };

  var offcanvasMenu = function() {

    $('#page').prepend('<div id="site-offcanvas" />');
    $('.header-logo-menu .container').prepend('<a href="#" class="js-site-nav-toggle site-nav-toggle site-nav-white"><i></i></a>');
    var clone1 = $('.theme-menu > ul').clone();
    $('#site-offcanvas').append(clone1);

    $('#site-offcanvas .has-dropdown').addClass('offcanvas-has-dropdown');
    $('#site-offcanvas')
      .find('li')
      .removeClass('has-dropdown');  

    // Hover dropdown menu on mobile
    $('.offcanvas-has-dropdown').mouseenter(function(){
      var $this = $(this);

      $this
        .addClass('active')
        .find('ul')
        .slideDown(500, 'easeOutExpo');       
      }).mouseleave(function(){

      var $this = $(this);
      $this
        .removeClass('active')
        .find('ul')
        .slideUp(500, 'easeOutExpo');       
      });

    $(window).resize(function(){

      if ( $('body').hasClass('offcanvas') ) {

        $('body').removeClass('offcanvas');
        $('.js-site-nav-toggle').removeClass('active');
        
      }
    });
  };


  var burgerMenu = function() {
    
    $('body').on('click', '.js-site-nav-toggle', function(event){
      var $this = $(this);

      if ( $('body').hasClass('overflow offcanvas') ) {
        $('body').removeClass('overflow offcanvas');
      } else {
        $('body').addClass('overflow offcanvas');
      }
      $this.toggleClass('active');
      event.preventDefault();

    });

  };

  $(window).load(function(){

    mobileMenuOutsideClick();
    offcanvasMenu();
    burgerMenu();

    // Preloader
    $('#status').fadeOut(); 
    $('#preloader').delay(350).fadeOut('slow'); 
    $('body').delay(350).css({'overflow':'visible'});
  

    // Dropdown Menu
    $('.theme-menu').find('li:has(ul)').addClass('has-menu');
    $(".sf-menu").superfish({
      delay: 1000,
      animation: {opacity:'show', height:'show'},
      speed: 'fast',
      autoArrows: true,
      speedOut: 'fast',
      disableHI: true
    });


    // ScrollTop   
    $('#toTop').fadeIn();
    $("#toTop").click(function(){
      $("html, body").animate({ scrollTop: 0 }, 600);
      return false;
    });  


    // Masonry
    $('.masonry').masonry({
      itemSelector: '.masonry-item',
      columnWidth: 0,
      isResizable: true,
      isAnimated: true,
      isFitWidth: true,
      animationOptions: { //add animations if you want
        duration: 750,
        easing: 'easeInOutExpo'
      }
    });


    // Modal
    $('.large-image-popup').magnificPopup({
      type: 'image',
      gallery:{enabled:true}
    });

    $('.modal-popup').magnificPopup({
      type: 'inline',

      fixedContentPos: false,
      fixedBgPos: true,

      overflowY: 'auto',

      closeBtnInside: true,
      preloader: false,

      midClick: true,
      removalDelay: 300,
      mainClass: 'my-mfp-zoom-in'
    });

    $('.popup-video').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      
      fixedContentPos: false
    });

    $('.simple-ajax-popup').magnificPopup({
      type: 'ajax'
    });

  });

})(jQuery);